module.exports = __webpack_public_path__ + "img/anniversaire1.09ba75ef.png";